/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ig-link-button{display:block;margin:8px;color:#41abf3}ig-link-button:hover{cursor:pointer}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/link.button/link.button.component.scss.ngstyle.js.pre-build-optimizer.js